module.exports = __webpack_public_path__ + "img/sun-setting-01.4d3c9352.svg";